const initialState = {
  loading: false,
  loaded: false,
  officer: null,
  stepCompleted: false,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_CLAIMS': {
      return initialState
    }

    case 'SET_OFFICER': {
      return {
        ...state,
        officer: action.payload.officer,
        stepCompleted: true,
      }
    }

    default: {
      return state
    }
  }
}
